"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _DocPass = _interopRequireDefault(require("@rsuite/icon-font/lib/file/DocPass"));

// Generated by script, don't edit it please.
var DocPass = (0, _createSvgIcon["default"])({
  as: _DocPass["default"],
  ariaLabel: 'doc pass',
  category: 'file',
  displayName: 'DocPass'
});
var _default = DocPass;
exports["default"] = _default;
module.exports = exports.default;